// @ts-nocheck
import React from 'react';
import { connect } from 'react-redux';
import SlideoutLayout from '../../../layout/slideout/SlideoutLayout';
import KwPanel from '../../../common/KwPanel';

import { deleteWorkflow } from '../../../../actions/workflowActions';
import { toast } from 'react-toastify';
import Button from '../../../common/Button';
import ConfirmationHeader from '../../../common/ConfirmationHeader';
import { useTranslation } from 'react-i18next';

export interface DeleteWorkflowProps {
  id?: string;
  cancel: () => void;
  done: () => void;
  deleteWorkflow: (id: string) => Promise<unknown>;
}

function Delete({ done, id, cancel, deleteWorkflow }: DeleteWorkflowProps) {
  const { t } = useTranslation();
  const handleDelete = () => {
    deleteWorkflow(id)
      .then(() => {
        toast.success(t('Workflow successfully deleted'));
        done();
      })
      .catch((ex) => {
        console.error(ex);
        toast.error(t('Failed to delete workflow'));
      });
  };

  return (
    <SlideoutLayout
      title={t('Delete confirmation')}
      cancel={cancel}
      done={done}
    >
      <KwPanel>
        <ConfirmationHeader text={t('Are you sure?')} />
        <Button
          className="btn btn-danger me-2"
          onClick={handleDelete}
          text={t('Yes, delete the workflow')}
        />
        <Button
          className="btn btn-default"
          onClick={cancel}
          autoFocus={true}
          text={t('No, cancel')}
        />
      </KwPanel>
    </SlideoutLayout>
  );
}

function mapStateToProps(state, ownProps) {
  return {};
}

const mapDispatchToProps = {
  deleteWorkflow,
};

export default connect(mapStateToProps, mapDispatchToProps)(Delete);
